module.exports = __webpack_public_path__ + "static/img/8.5d6d7bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/zh/8.png
// module id = RvV3
// module chunks = 0